export default __webpack_public_path__ + "static/media/hu.bcbd2770.svg";